module.exports = __webpack_public_path__ + "img/theme-four.e9dded5c.png";